const SECONDARY_LEVEL_CODES = new Set(["Form1", "Form2", "Form3", "Form4"]);
const PRIMARY_LEVEL_CODES = new Set(["Std1", "Std2", "Std3", "Std4", "Std5", "Std6", "Std7", "Std8"]);

function normalizeCode(value) {
    return String(value || "")
        .trim()
        .replace(/\s+/g, "");
}

function deriveLevelCodeFromName(sclassName) {
    const name = String(sclassName || "").trim();
    if (!name) return "";

    const compact = normalizeCode(name);

    const formFromName =
        name.match(/^form\s*([1-4])(?:\s|$|[-/]|[a-z])/i) ||
        compact.match(/^form([1-4])(?:[a-z]|$)/i);
    if (formFromName) return `Form${formFromName[1]}`;

    const stdFromName =
        name.match(/^std(?:andard)?\s*([1-8])(?:\s|$|[-/])/i) || compact.match(/^std([1-8])$/i);
    if (stdFromName) return `Std${stdFromName[1]}`;

    return "";
}

function coerceSecondaryLevelCode(rawCode, educationLevel) {
    const code = normalizeCode(rawCode);
    if (SECONDARY_LEVEL_CODES.has(code) || PRIMARY_LEVEL_CODES.has(code)) return code;
    const edu = String(educationLevel || "")
        .trim()
        .toLowerCase();
    if (edu !== "secondary" && edu !== "") return code;
    if (code === "1") return "Form1";
    if (code === "2") return "Form2";
    if (code === "3") return "Form3";
    if (code === "4") return "Form4";
    return code;
}

export function getClassLevelCode(cls) {
    const fromField = coerceSecondaryLevelCode(cls?.levelCode, cls?.educationLevel);
    if (fromField && (SECONDARY_LEVEL_CODES.has(fromField) || PRIMARY_LEVEL_CODES.has(fromField))) {
        return fromField;
    }
    return deriveLevelCodeFromName(cls?.sclassName);
}

export function getPrimaryStandardLevel(cls) {
    const code = getClassLevelCode(cls);
    if (/^Std[1-8]$/.test(code)) {
        return `Std ${code.slice(3)}`;
    }
    const name = String(cls?.sclassName || "").trim();
    const m = name.match(/^std(?:andard)?\s*([1-8])\b/i);
    if (m) return `Std ${m[1]}`;
    return null;
}

export function matchesSecondaryClass(cls) {
    const level = String(cls?.educationLevel || "")
        .trim()
        .toLowerCase();
    if (level === "secondary") return true;

    const code = getClassLevelCode(cls);
    if (SECONDARY_LEVEL_CODES.has(code)) return true;

    const name = String(cls?.sclassName || "").trim();
    if (/^form\s*[1-4]\b/i.test(name)) return true;

    return false;
}

/** @returns {"Form 1"|"Form 2"|"Form 3"|"Form 4"|null} */
export function getSecondaryFormLevel(cls) {
    const code = getClassLevelCode(cls);
    if (SECONDARY_LEVEL_CODES.has(code)) {
        return `Form ${code.slice(-1)}`;
    }
    const name = String(cls?.sclassName || "").trim();
    const m = name.match(/^form\s*([1-4])\b/i);
    if (m) return `Form ${m[1]}`;
    return null;
}

export function matchesPrimaryClass(cls) {
    if (!cls) return false;
    // Form 1–4 classes must use secondary subject catalogue even if educationLevel is mis-set.
    if (matchesSecondaryClass(cls)) return false;

    const level = String(cls?.educationLevel || "")
        .trim()
        .toLowerCase();
    if (level === "primary") return true;

    const code = getClassLevelCode(cls);
    if (PRIMARY_LEVEL_CODES.has(code)) return true;

    const name = String(cls?.sclassName || "").trim();
    if (/^std(?:andard)?\s*[1-8]\b/i.test(name)) return true;

    return false;
}
